import ScrollSpy from "./lib/scrollspy_updates.js";
import ScrollAnimation from "./lib/scroll-animation.js";
import ScrollVideo from "./lib/scroll-video.js";
import MusickitPreview from "./lib/musickit-preview.js";
import UpdateMobileNavigation from "./lib/update-mobile-navigation.js";

window.addEventListener('load', function() {

	let scrollSpy = new ScrollSpy({menu: "#navigation", container: "#scrollspy"});

	ScrollAnimation.init();
	ScrollVideo.init();
	MusickitPreview.init();
	UpdateMobileNavigation.init();

	var loader = document.querySelector("#update-loader");
	loader.style.display = "none";

});
